import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import Header from '../Header/Header';
import containerStyles from './container.module.css';

const MainLayout: React.FC = () => {
  return (
    <div style={{ display: 'flex', width: '100vw', height: '100vh' }}>
      {/* Sidebar fica fixa à esquerda */}
      <Sidebar />
      
      {/* Container da direita que contém Header + Conteúdo */}
      <div style={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column',
        marginLeft: '72px' /* Espaço exato da Sidebar colapsada do Synweb */
      }}>
        <Header />
        {/* O <main> é o container de scroll (não o body): preenche a altura
            que sobra abaixo do Header e rola por dentro — assim a barra de
            rolagem nunca afeta a sidebar nem o header. alignItems flex-start
            evita corte do topo do conteúdo alto; paddingBottom dá respiro no
            fim da página. */}
        <main
          className={containerStyles.containerPage}
          style={{
            paddingLeft: 0,
            paddingBottom: 40,
            flex: 1,
            minHeight: 0,
            alignItems: 'flex-start',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
           <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;